<div class="footer">
  <div class="footer-content">
    <div class="footer-content__menu">
      @for (item of links; track item) {
        @if (
          item?.route &&
          (!item?.requireLogin || (item?.requireLogin && isLoggin))
          ) {
          <a
            [routerLink]="item.route ?? '' | translateRouterLink"
            target="_self"
            title="{{ item.label | translate }}"
            >{{ item.label | translate }}</a
            >
          }
        }
      </div>

      <div class="footer-content__copyright">
        © 2001-{{ currentYear }}
        {{ labelPrefix + 'TXT_COPY-RIGHT' | translate }}
      </div>
    </div>
  </div>
